export type ThemeMode = "dark" | "light";

export type CockpitColorTokens = {
  background: string;
  panel: string;
  panelRaised: string;
  panelHighest: string;
  line: string;
  lineStrong: string;
  text: string;
  muted: string;
  faint: string;
  green: string;
  amber: string;
  red: string;
  blue: string;
};

export const cockpitColorTokens: Record<ThemeMode, CockpitColorTokens> = {
  dark: {
    background: "#0A101B",
    panel: "#101827",
    panelRaised: "#16202F",
    panelHighest: "#1C2939",
    line: "#1F2C40",
    lineStrong: "#2A3A52",
    text: "#E9EEF6",
    muted: "#8B97AB",
    faint: "#5A6779",
    green: "#34C77B",
    amber: "#FFB224",
    red: "#FF5C57",
    blue: "#6AA6FF",
  },
  light: {
    background: "#EDF0F5",
    panel: "#FFFFFF",
    panelRaised: "#F5F7FB",
    panelHighest: "#EBEFF6",
    line: "#E1E6EE",
    lineStrong: "#CDD5E1",
    text: "#141D2B",
    muted: "#5C6A7E",
    faint: "#93A0B2",
    green: "#159A5B",
    amber: "#B26A00",
    red: "#D6362F",
    blue: "#2E6BDF",
  },
};
